import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate, useLocation } from "react-router-dom";
import RotaProtegida from "../components/base/RotaProtegida";

// Cada página vira um pedaço próprio do bundle: o portal não baixa o Console nem a UPA VET.
const NotFound = lazy(() => import("../pages/NotFound"));
const AdminLoginPage = lazy(() => import("../pages/admin/login/page"));
const AdminPrimeiroAcessoPage = lazy(() => import("../pages/admin/primeiro-acesso/page"));
const AdminTrocarSenhaPage = lazy(() => import("../pages/admin/trocar-senha/page"));
const AdminDashboardPage = lazy(() => import("../pages/admin/page"));
const AdminPerfilPage = lazy(() => import("../pages/admin/perfil/page"));
const AdminSegurancaPage = lazy(() => import("../pages/admin/seguranca/page"));
const AdminMfaCadastroPage = lazy(() => import("../pages/admin/seguranca/mfa/page"));
const AdminUsuariosPage = lazy(() => import("../pages/admin/usuarios/page"));
const AdminPerfisPermissoesPage = lazy(() => import("../pages/admin/usuarios/perfis/page"));
const AdminUsuarioAcessoPage = lazy(() => import("../pages/admin/usuarios/acesso/page"));
const AdminAuditoriaPage = lazy(() => import("../pages/admin/auditoria/page"));
const AdminEmailsPage = lazy(() => import("../pages/admin/emails/page"));
const AdminModuloPage = lazy(() => import("../pages/admin/modulo/page"));
const AdminGaleriaPage = lazy(() => import("../pages/admin/galeria/page"));
const AdminGaleriaManualPage = lazy(() => import("../pages/admin/galeria/manual/page"));
const AdminEvolucaoCadastralPage = lazy(() => import("../pages/admin/evolucao-cadastral/page"));
const AdminDesignSystemPage = lazy(() => import("../pages/admin/design-system/page"));
const AdminContratosDominioPage = lazy(() => import("../pages/admin/contratos-dominio/page"));
const AdminVinculosPessoaOrganizacaoPage = lazy(() => import("../pages/admin/vinculos-pessoa-organizacao/page"));
const AdminVinculosAnimalPage = lazy(() => import("../pages/admin/vinculos-animal/page"));
const AdminClassificacaoAnimalPage = lazy(() => import("../pages/admin/classificacao-animal/page"));
const AdminRgaPage = lazy(() => import("../pages/admin/rga/page"));
const AdminRgaMunicipalPage = lazy(() => import("../pages/admin/rga-municipal/page"));
const AdminApiIntegracoesPage = lazy(() => import("../pages/admin/api-integracoes/page"));
const AdminFuncoesEspeciaisPage = lazy(() => import("../pages/admin/funcoes-especiais/page"));
const AdminIndicadoresPage = lazy(() => import("../pages/admin/indicadores/page"));
const AdminHomologacaoPage = lazy(() => import("../pages/admin/homologacao/page"));
const AdminDomicilioAnimalPage = lazy(() => import("../pages/admin/domicilio-animal/page"));
const AdminCredenciamentoEspecialPage = lazy(() => import("../pages/admin/credenciamento-especial/page"));
const AdminOperacionalPage = lazy(() => import("../pages/admin/operacional/page"));
const AdminPessoasPage = lazy(() => import("../pages/admin/cadastros/pessoas/page"));
const AdminPessoasRevisaoBairrosPage = lazy(() => import("../pages/admin/cadastros/pessoas/revisao-bairros/page"));
const AdminPessoasManualPage = lazy(() => import("../pages/admin/cadastros/pessoas/manual/page"));
const AdminAnimaisPage = lazy(() => import("../pages/admin/cadastros/animais/page"));
const AdminAnimaisManualPage = lazy(() => import("../pages/admin/cadastros/animais/manual/page"));
const AdminOrganizacoesManualPage = lazy(() => import("../pages/admin/cadastros/organizacoes/manual/page"));
const AdminOrganizacoesPage = lazy(() => import("../pages/admin/cadastros/organizacoes/page"));
const AdminDocumentosPage = lazy(() => import("../pages/admin/gestao/documentos/page"));
const AdminTerritorioBairrosPage = lazy(() => import("../pages/admin/operacional/territorio/bairros/page"));
const AdminTerritorioRegioesPage = lazy(() => import("../pages/admin/operacional/territorio/regioes/page"));
const AdminTerritorioManualPage = lazy(() => import("../pages/admin/operacional/territorio/manual/page"));
const AdminCastrometroManualPage = lazy(() => import("../pages/admin/operacional/castrometro/manual/page"));
const AdminCampanhasVisaoGeralPage = lazy(() => import("../pages/admin/operacional/campanhas/visao-geral/page"));
const AdminCampanhasListaPage = lazy(() => import("../pages/admin/operacional/campanhas/lista/page"));
const AdminCampanhaDetalhePage = lazy(() => import("../pages/admin/operacional/campanhas/lista/detalhe/page"));
const AdminCampanhasExecutoresPage = lazy(() => import("../pages/admin/operacional/campanhas/executores/page"));
const AdminNaaInscricoesPage = lazy(() => import("../pages/admin/operacional/campanhas/inscricoes/page"));
const AdminNaaInscricaoDetalhePage = lazy(() => import("../pages/admin/operacional/campanhas/inscricoes/detalhe/page"));
const AdminNaaOcorrenciasPage = lazy(() => import("../pages/admin/operacional/campanhas/ocorrencias/page"));
const AdminCampanhasExecutorDetalhePage = lazy(() => import("../pages/admin/operacional/campanhas/executores/detalhe/page"));
const AdminZoonosesPage = lazy(() => import("../pages/admin/operacional/saude/zoonoses/page"));
const AdminZoonosesOficiosPage = lazy(() => import("../pages/admin/operacional/saude/zoonoses/oficios/page"));
const AdminZoonosesCatalogoPage = lazy(() => import("../pages/admin/operacional/saude/zoonoses/catalogo/page"));
const AdminRedeProtecaoPage = lazy(() => import("../pages/admin/rede-protecao/page"));
const AdminVistoriasCampoPage = lazy(() => import("../pages/admin/vistorias-campo/page"));
const AdminVistoriaCampoDetalhePage = lazy(() => import("../pages/admin/vistorias-campo/detalhe/page"));
const AdminVistoriasCampoManualPage = lazy(() => import("../pages/admin/vistorias-campo/manual/page"));
const CampoPage = lazy(() => import("../pages/campo/page"));
const UpavetAtendimentosPage = lazy(() => import("../pages/upavet/atendimentos/page"));
const UpavetProcedimentosPage = lazy(() => import("../pages/upavet/procedimentos/page"));
const UpavetCastrometroPage = lazy(() => import("../pages/upavet/castrometro/page"));
const UpavetConsolidacaoPage = lazy(() => import("../pages/upavet/consolidacao/page"));
const UpavetCadastrosPage = lazy(() => import("../pages/upavet/cadastros/page"));
const UpavetAuditoriaPage = lazy(() => import("../pages/upavet/auditoria/page"));
const UpavetTransparenciaPage = lazy(() => import("../pages/upavet/transparencia/page"));
const UpavetIndicadoresPage = lazy(() => import("../pages/upavet/indicadores/page"));
const UpavetCustosPage = lazy(() => import("../pages/upavet/custos/page"));
const UpavetExecutivoPage = lazy(() => import("../pages/upavet/executivo/page"));
const UpavetForaGoianiaPage = lazy(() => import("../pages/upavet/fora-goiania/page"));
const UpavetAdminTutoresPage = lazy(() => import("../pages/upavet/admin/tutores/page"));
const UpavetAdminAnimaisPage = lazy(() => import("../pages/upavet/admin/animais/page"));
const UpavetAdminTutorAnimaisPage = lazy(() => import("../pages/upavet/admin/tutor-animais/page"));
const UpavetDiagnosticoPage = lazy(() => import("../pages/upavet/diagnostico/page"));
const Home = lazy(() => import("../pages/home/page"));
const GoianiaPage = lazy(() => import("../pages/goiania/page"));
const CastrometroPanelPage = lazy(() => import("../pages/goiania/castrometro/page"));
const UpavetPanelPage = lazy(() => import("../pages/goiania/upavet/page"));
const UpavetHospitalPage = lazy(() => import("../pages/goiania/upavet-hospital/page"));
const BalcaoAdocaoPage = lazy(() => import("../pages/goiania/balcao-de-adocao/page"));
const BalcaoDesaparecidosPage = lazy(() => import("../pages/goiania/balcao-de-desaparecidos/page"));
const CadernetaDigitalPage = lazy(() => import("../pages/goiania/caderneta-digital/page"));
const MinhaAreaPage = lazy(() => import("../pages/goiania/minha-area/page"));
const MinhaAreaLoginPage = lazy(() => import("../pages/goiania/minha-area/entrar/page"));
const MinhaAreaCadastroPage = lazy(() => import("../pages/goiania/minha-area/cadastro/page"));
const MinhaAreaPainelPage = lazy(() => import("../pages/goiania/minha-area/painel/page"));
const MinhaAreaContaPage = lazy(() => import("../pages/goiania/minha-area/conta/page"));
const MinhaAreaAnimalPage = lazy(() => import("../pages/goiania/minha-area/animal/page"));
const MinhaAreaAdocaoPage = lazy(() => import("../pages/goiania/minha-area/adocao/page"));
const MinhaAreaOrganizacaoPage = lazy(() => import("../pages/goiania/minha-area/organizacao/page"));
const MinhaAreaGuiaPage = lazy(() => import("../pages/goiania/minha-area/guia/page"));
const MinhaAreaRgaPage = lazy(() => import("../pages/goiania/minha-area/rga/page"));
const MinhaAreaTelemedicinaPage = lazy(() => import("../pages/goiania/minha-area/telemedicina/page"));
const MinhaAreaTelemedicinaNovoPage = lazy(() => import("../pages/goiania/minha-area/telemedicina/novo/page"));
const MinhaAreaTelemedicinaHabilitacaoPage = lazy(() => import("../pages/goiania/minha-area/telemedicina/habilitacao/page"));
const AdminTelemedicinaPage = lazy(() => import("../pages/admin/telemedicina/page"));
const UpavetTelemedicinaPage = lazy(() => import("../pages/upavet/telemedicina/page"));
const CadernetaCompartilhadaPage = lazy(() => import("../pages/goiania/caderneta/compartilhada/page"));
const VerificarCadernetaPage = lazy(() => import("../pages/verificar/caderneta/page"));
const VerificarCredencialPage = lazy(() => import("../pages/verificar/credencial/page"));
const VerificarVistoriaPage = lazy(() => import("../pages/verificar/vistoria/page"));
const SobreABeaaPage = lazy(() => import("../pages/goiania/sobre-a-beaa/page"));
const BemEstarAnimalPage = lazy(() => import("../pages/goiania/bem-estar-animal/page"));
const GaleriaPage = lazy(() => import("../pages/goiania/galeria/page"));
const ComoDenunciarPage = lazy(() => import("../pages/goiania/como-denunciar/page"));
const MaringaPage = lazy(() => import("../pages/maringa/page"));
const CensoGoianiaPage = lazy(() => import("../pages/censo-goiania/page"));
const CensoGoiasPage = lazy(() => import("../pages/censo-goias/page"));
const CensoMaringaPage = lazy(() => import("../pages/censo-maringa/page"));
const CensoPage = lazy(() => import("../pages/censo/page"));
const AllCampaignsPage = lazy(() => import("../pages/campanhas/page"));
const CampaignDetailPage = lazy(() => import("../pages/campanhas/detalhes/page"));
const PoliticaPrivacidadePage = lazy(() => import("../pages/goiania/politica-de-privacidade/page"));
const TermosUsoPage = lazy(() => import("../pages/goiania/termos-de-uso/page"));
const TelemedicinaComoFuncionaPage = lazy(() => import("../pages/goiania/telemedicina/page"));
const GoiasPoliticaPrivacidadePage = lazy(() => import("../pages/goias/politica-de-privacidade/page"));
const GoiasTermosUsoPage = lazy(() => import("../pages/goias/termos-de-uso/page"));
const MaringaPoliticaPrivacidadePage = lazy(() => import("../pages/maringa/politica-de-privacidade/page"));
const MaringaTermosUsoPage = lazy(() => import("../pages/maringa/termos-de-uso/page"));


/** Endereço antigo da home: leva para a raiz mantendo a âncora (ex.: /goiania#campanhas → /#campanhas). */
function HomeAntiga() {
  const { search, hash } = useLocation();
  return <Navigate to={`/${search}${hash}`} replace />;
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <GoianiaPage />,
  },
  {
    path: "/goias",
    element: <Home />,
  },
  {
    path: "/goiania",
    element: <HomeAntiga />,
  },
  {
    path: "/goiania/castrometro",
    element: <CastrometroPanelPage />,
  },
  {
    path: "/goiania/upavet",
    element: <UpavetPanelPage />,
  },
  {
    path: "/goiania/upavet/hospital",
    element: <UpavetHospitalPage />,
  },
  {
    path: "/goiania/balcao-de-adocao",
    element: <BalcaoAdocaoPage />,
  },
  {
    path: "/goiania/balcao-de-desaparecidos",
    element: <BalcaoDesaparecidosPage />,
  },
  {
    path: "/goiania/caderneta-digital",
    element: <CadernetaDigitalPage />,
  },
  {
    path: "/goiania/minha-area",
    element: <MinhaAreaPage />,
  },
  {
    path: "/goiania/minha-area/entrar",
    element: <MinhaAreaLoginPage />,
  },
  {
    path: "/goiania/minha-area/cadastro",
    element: <MinhaAreaCadastroPage />,
  },
  {
    path: "/goiania/minha-area/painel",
    element: <MinhaAreaPainelPage />,
  },
  {
    path: "/goiania/minha-area/conta",
    element: <MinhaAreaContaPage />,
  },
  {
    path: "/goiania/minha-area/animal",
    element: <MinhaAreaAnimalPage />,
  },
  {
    path: "/goiania/minha-area/adocao",
    element: <MinhaAreaAdocaoPage />,
  },
  {
    path: "/goiania/minha-area/organizacao",
    element: <MinhaAreaOrganizacaoPage />,
  },
  {
    path: "/goiania/minha-area/guia",
    element: <MinhaAreaGuiaPage />,
  },
  {
    path: "/goiania/minha-area/rga",
    element: <MinhaAreaRgaPage />,
  },
  {
    path: "/goiania/minha-area/telemedicina",
    element: <MinhaAreaTelemedicinaPage />,
  },
  {
    path: "/goiania/minha-area/telemedicina/novo",
    element: <MinhaAreaTelemedicinaNovoPage />,
  },
  {
    path: "/goiania/minha-area/telemedicina/habilitacao",
    element: <MinhaAreaTelemedicinaHabilitacaoPage />,
  },
  {
    // Verificação pública do PDF da caderneta (código e hash impressos no documento).
    path: "/verificar/caderneta",
    element: <VerificarCadernetaPage />,
  },
  {
    path: "/verificar/caderneta/:codigo",
    element: <VerificarCadernetaPage />,
  },
  {
    // Verificação pública da credencial municipal de função especial.
    path: "/verificar/credencial",
    element: <VerificarCredencialPage />,
  },
  {
    path: "/verificar/credencial/:codigo",
    element: <VerificarCredencialPage />,
  },
  {
    // Verificação pública dos documentos do PETBEA Campo (laudo, relatório, termo…): só metadados e hash.
    path: "/verificar/vistoria",
    element: <VerificarVistoriaPage />,
  },
  {
    path: "/verificar/vistoria/:codigo",
    element: <VerificarVistoriaPage />,
  },
  {
    // Link curto da caderneta compartilhada (QR Code): página pública, somente leitura.
    path: "/c/:token",
    element: <CadernetaCompartilhadaPage />,
  },
  {
    path: "/goiania/sobre-a-beaa",
    element: <SobreABeaaPage />,
  },
  {
    path: "/goiania/bem-estar-animal",
    element: <BemEstarAnimalPage />,
  },
  {
    path: "/goiania/galeria",
    element: <GaleriaPage />,
  },
  {
    path: "/goiania/como-denunciar",
    element: <ComoDenunciarPage />,
  },
  {
    path: "/maringa",
    element: <MaringaPage />,
  },
  {
    path: "/censo-goiania",
    element: <CensoGoianiaPage />,
  },
  {
    path: "/censo-goias",
    element: <CensoGoiasPage />,
  },
  {
    path: "/censo-maringa",
    element: <CensoMaringaPage />,
  },
  {
    path: "/censo",
    element: <CensoPage />,
  },
  {
    path: "/campanhas/:id",
    element: <CampaignDetailPage />,
  },
  {
    path: "/campanhas",
    element: <AllCampaignsPage />,
  },
  {
    path: "/goiania/politica-de-privacidade",
    element: <PoliticaPrivacidadePage />,
  },
  {
    path: "/goiania/termos-de-uso",
    element: <TermosUsoPage />,
  },
  {
    // Página pública: modalidades oferecidas e legislação da telemedicina (indicada pela Tela T).
    path: "/goiania/telemedicina",
    element: <TelemedicinaComoFuncionaPage />,
  },
  {
    path: "/goias/politica-de-privacidade",
    element: <GoiasPoliticaPrivacidadePage />,
  },
  {
    path: "/goias/termos-de-uso",
    element: <GoiasTermosUsoPage />,
  },
  {
    path: "/maringa/politica-de-privacidade",
    element: <MaringaPoliticaPrivacidadePage />,
  },
  {
    path: "/maringa/termos-de-uso",
    element: <MaringaTermosUsoPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin/primeiro-acesso",
    element: <AdminPrimeiroAcessoPage />,
  },
  {
    path: "/admin/trocar-senha",
    element: <AdminTrocarSenhaPage />,
  },
  {
    path: "/admin",
    element: <AdminDashboardPage />,
  },
  {
    path: "/admin/perfil",
    element: <AdminPerfilPage />,
  },
  {
    // Central de Telemedicina (DIRBEA). Sem recurso de permissão próprio ainda (decisão P-11):
    // só exige o login do console, e não exibe dado nenhum.
    path: "/admin/telemedicina",
    element: <AdminTelemedicinaPage />,
  },
  {
    path: "/admin/seguranca",
    element: <AdminSegurancaPage />,
  },
  {
    // Cadastro obrigatório do segundo fator quando o perfil exige MFA.
    path: "/admin/seguranca/mfa",
    element: <AdminMfaCadastroPage />,
  },
  {
    path: "/admin/usuarios",
    element: <AdminUsuariosPage />,
  },
  {
    path: "/admin/usuarios/perfis",
    element: <AdminPerfisPermissoesPage />,
  },
  {
    path: "/admin/usuarios/:userId/acesso",
    element: <AdminUsuarioAcessoPage />,
  },
  {
    path: "/admin/auditoria",
    element: <AdminAuditoriaPage />,
  },
  {
    path: "/admin/emails",
    element: <AdminEmailsPage />,
  },
  {
    path: "/admin/modulo/:slug",
    element: <AdminModuloPage />,
  },
  {
    path: "/admin/galeria",
    element: <AdminGaleriaPage />,
  },
  {
    path: "/admin/galeria/manual",
    element: <AdminGaleriaManualPage />,
  },
  {
    // Etapa 01 da evolução cadastral: diagnóstico e plano aditivo (RGA, vínculos,
    // responsabilidade, domicílio/IPTU e certificação de funções especiais).
    // Página de projeto — não é portal público e não altera os fluxos legados.
    path: "/admin/evolucao-cadastral",
    element: <AdminEvolucaoCadastralPage />,
  },
  {
    // Etapa 02 da evolução cadastral: design system, navegação agrupada e
    // componentes transversais de identidade, vínculos e comprovação.
    // O menu do Console permanece intocado nesta etapa.
    path: "/admin/design-system",
    element: <AdminDesignSystemPage />,
  },
  {
    // Etapa 03 da evolução cadastral: contratos de domínio, dicionário de dados,
    // DER navegável, DTOs versionados e esquema aditivo proposto (sem migration).
    path: "/admin/contratos-dominio",
    element: <AdminContratosDominioPage />,
  },
  {
    // Etapa 04 da evolução cadastral: perfis globais da pessoa, vínculo
    // institucional com papel, vigência e comprovação, e separação entre
    // perfil, vínculo cadastral e permissão administrativa.
    path: "/admin/vinculos-pessoa-organizacao",
    element: <AdminVinculosPessoaOrganizacaoPage />,
  },
  {
    // Etapa 05 da evolução cadastral: vínculos N:N entre pessoas, organizações
    // e animais, papéis distintos, evidências, responsável principal e
    // transferência formal com protocolo (sem migration executada).
    path: "/admin/vinculos-animal",
    element: <AdminVinculosAnimalPage />,
  },
  {
    // Etapa 06: classificação multidimensional do animal — espécie, natureza,
    // função, condição de cuidado, etapa funcional e comprovação, com histórico.
    path: "/admin/classificacao-animal",
    element: <AdminClassificacaoAnimalPage />,
  },
  {
    // Etapa 07: RGA municipal — numeração proposta, reserva idempotente,
    // legado, conflitos, carteira e identificação por microchip.
    path: "/admin/rga",
    element: <AdminRgaPage />,
  },
  {
    // Etapa 11: painel de RGA municipal ligado ao ledger REAL (reserva interna,
    // RGA histórico preservado, reconciliação e bloqueio de emissão oficial).
    path: "/admin/rga-municipal",
    element: <AdminRgaMunicipalPage />,
  },
  {
    // Etapa 12: contratos da API v1, conexões institucionais reais, outbox de
    // eventos e observabilidade — tudo lido da função de borda `api-v1`.
    path: "/admin/api-integracoes",
    element: <AdminApiIntegracoesPage />,
  },
  {
    // Processos REAIS de função especial do animal (petbea_cred_*): abertura,
    // documentos, parecer, exigência e decisão, com as travas do banco.
    path: "/admin/funcoes-especiais",
    element: <AdminFuncoesEspeciaisPage />,
  },
  {
    // Etapa 14: indicadores executivos e territoriais sobre a base real
    // (RGA, animais, vínculos, credenciamento, território e qualidade do dado).
    path: "/admin/indicadores",
    element: <AdminIndicadoresPage />,
  },
  {
    // Etapa 15: homologação final — baseline, dry-run somente leitura, matriz
    // de testes T01–T22 e checklist go/no-go sobre a base real.
    path: "/admin/homologacao",
    element: <AdminHomologacaoPage />,
  },
  {
    // Etapa 08: domicílio e territorialidade animal — vínculo animal–moradia com
    // vigência e histórico, IPTU como referência do imóvel, exceção sem IPTU,
    // animais comunitários e privacidade da visão pública.
    path: "/admin/domicilio-animal",
    element: <AdminDomicilioAnimalPage />,
  },
  {
    // Etapa 09: modalidades, requisitos e matriz de credenciamento especial —
    // catálogo versionado com autoridade emissora, documentos e bloqueio de
    // emissão quando não há ato administrativo habilitante.
    path: "/admin/credenciamento-especial",
    element: <AdminCredenciamentoEspecialPage />,
  },
  {
    path: "/admin/operacional/territorio/bairros",
    element: <AdminTerritorioBairrosPage />,
  },
  {
    path: "/admin/operacional/territorio/mapa",
    element: <AdminTerritorioBairrosPage />,
  },
  {
    path: "/admin/operacional/territorio/regioes",
    element: <AdminTerritorioRegioesPage />,
  },
  {
    path: "/admin/operacional/territorio/manual",
    element: <AdminTerritorioManualPage />,
  },
  {
    path: "/admin/operacional/castrometro/manual",
    element: <AdminCastrometroManualPage />,
  },
  {
    // Campanhas: menu por etapa do processo (Visão geral, lista única por tipo, Executores).
    path: "/admin/operacional/campanhas/visao-geral",
    element: <AdminCampanhasVisaoGeralPage />,
  },
  {
    // Lista única de campanhas (castração e CED como base; filtro ?tipo=).
    path: "/admin/operacional/campanhas/campanhas",
    element: <AdminCampanhasListaPage />,
  },
  {
    path: "/admin/operacional/campanhas/campanhas/:id",
    element: <AdminCampanhaDetalhePage />,
  },
  // Endereços antigos (um item por tipo) caem na lista única já filtrada.
  ...[
    ["castracao", "castracao"],
    ["vacinacao", "vacinacao"],
    ["microchipagem", "microchipagem"],
    ["eventos", "educativa"],
  ].map(([antigo, tipo]) => ({
    path: `/admin/operacional/campanhas/${antigo}`,
    element: <Navigate to={`/admin/operacional/campanhas/campanhas?tipo=${tipo}`} replace />,
  })),
  {
    // NAA — etapas 01 a 03: pré-inscrição, identificação física (RFID) e elegibilidade.
    path: "/admin/operacional/campanhas/inscricoes",
    element: <AdminNaaInscricoesPage />,
  },
  {
    path: "/admin/operacional/campanhas/inscricoes/:id",
    element: <AdminNaaInscricaoDetalhePage />,
  },
  {
    // NAA — ocorrências (divergência de chip, duplicidade, leitor indisponível…) com responsável e decisão.
    path: "/admin/operacional/campanhas/ocorrencias",
    element: <AdminNaaOcorrenciasPage />,
  },
  {
    // Habilitação dos executores (clínica, hospital, unidade móvel, equipe) com documentos e vencimentos.
    path: "/admin/operacional/campanhas/executores",
    element: <AdminCampanhasExecutoresPage />,
  },
  {
    path: "/admin/operacional/campanhas/executores/:id",
    element: <AdminCampanhasExecutorDetalhePage />,
  },
  {
    // Vigilância de zoonoses: agravos notificados, fila de investigação e casos.
    path: "/admin/operacional/saude/zoonoses",
    element: <AdminZoonosesPage />,
  },
  {
    // Painel global dos ofícios de bloqueio sanitário emitidos pela vigilância.
    path: "/admin/operacional/saude/zoonoses/oficios",
    element: <AdminZoonosesOficiosPage />,
  },
  {
    // Catálogo técnico dos agravos: causa, infecção, sintomas, carga e impactos.
    path: "/admin/operacional/saude/zoonoses/catalogo",
    element: <AdminZoonosesCatalogoPage />,
  },
  {
    path: "/admin/operacional/:grupo/:item",
    element: <AdminOperacionalPage />,
  },
  {
    path: "/admin/operacional/cadastros/pessoas",
    element: <AdminPessoasPage />,
  },
  {
    path: "/admin/operacional/cadastros/animais",
    element: <AdminAnimaisPage />,
  },
  {
    path: "/admin/operacional/cadastros/animais/manual",
    element: <AdminAnimaisManualPage />,
  },
  {
    path: "/admin/operacional/cadastros/pessoas/manual",
    element: <AdminPessoasManualPage />,
  },
  {
    // Fila de revisão de bairro por CEP (Cadastros › Pessoas).
    path: "/admin/operacional/cadastros/pessoas/revisao-bairros",
    element: <AdminPessoasRevisaoBairrosPage />,
  },
  {
    // Mesmo caminho citado nas especificações da tela.
    path: "/admin/cadastros/pessoas/revisao-bairros",
    element: <AdminPessoasRevisaoBairrosPage />,
  },
  {
    path: "/admin/operacional/cadastros/organizacoes/manual",
    element: <AdminOrganizacoesManualPage />,
  },
  {
    path: "/admin/operacional/cadastros/organizacoes",
    element: <AdminOrganizacoesPage />,
  },
  {
    // Cadastro de OSC migrou para a aba "OSC" dos Cadastros da UPA VET.
    path: "/admin/cadastros/oscs",
    element: <Navigate to="/upavet/cadastros?aba=osc" replace />,
  },
  {
    // OSC, instrumento, plano de trabalho e habilitação são cadastros da UPA VET.
    // As rotas antigas do Console redirecionam para as abas de lá.
    path: "/admin/cadastros/instrumentos",
    element: <Navigate to="/upavet/cadastros?aba=instrumentos" replace />,
  },
  {
    path: "/admin/cadastros/planos",
    element: <Navigate to="/upavet/cadastros?aba=plano" replace />,
  },
  {
    path: "/admin/cadastros/habilitacao",
    element: <Navigate to="/upavet/cadastros?aba=habilitacao" replace />,
  },
  {
    path: "/admin/gestao/documentos",
    element: <AdminDocumentosPage />,
  },
  {
    path: "/admin/rede-protecao",
    element: <AdminRedeProtecaoPage />,
  },
  {
    path: "/admin/rede-protecao/:aba",
    element: <AdminRedeProtecaoPage />,
  },
  {
    path: "/admin/vistorias-campo",
    element: <AdminVistoriasCampoPage />,
  },
  {
    path: "/admin/vistorias-campo/manual",
    element: <AdminVistoriasCampoManualPage />,
  },
  {
    path: "/admin/vistorias-campo/:id",
    element: <AdminVistoriaCampoDetalhePage />,
  },
  {
    // PETBEA Campo: app interno (PWA) das vistorias, com manifest e service worker próprios em /campo/.
    path: "/campo/*",
    element: <CampoPage />,
  },
  {
    path: "/upavet",
    element: (
      <RotaProtegida recurso="UPAVET_ATENDIMENTOS">
        <UpavetAtendimentosPage />
      </RotaProtegida>
    ),
  },
  {
    // Mesmo recurso das demais telas de atendimento da UPA VET; recurso próprio é decisão P-11.
    path: "/upavet/telemedicina",
    element: (
      <RotaProtegida recurso="UPAVET_ATENDIMENTOS">
        <UpavetTelemedicinaPage />
      </RotaProtegida>
    ),
  },
  {
    path: "/upavet/atendimentos",
    element: (
      <RotaProtegida recurso="UPAVET_ATENDIMENTOS">
        <UpavetAtendimentosPage />
      </RotaProtegida>
    ),
  },
  {
    path: "/upavet/procedimentos",
    element: (
      <RotaProtegida recurso="UPAVET_PROCEDIMENTOS" recursoAlternativo="UPAVET_CATALOGO">
        <UpavetProcedimentosPage />
      </RotaProtegida>
    ),
  },
  {
    path: "/upavet/castrometro",
    element: (
      <RotaProtegida recurso="UPAVET_CASTROMETRO">
        <UpavetCastrometroPage />
      </RotaProtegida>
    ),
  },
  {
    // Consolidação e Conciliação vivem na mesma tela, separadas por abas.
    // Quem tem qualquer uma das duas permissões entra.
    path: "/upavet/consolidacao",
    element: (
      <RotaProtegida recurso="UPAVET_CONSOLIDACAO" recursoAlternativo="UPAVET_CONCILIACAO">
        <UpavetConsolidacaoPage />
      </RotaProtegida>
    ),
  },
  {
    // Rota antiga da conciliação: mantida para não quebrar links e favoritos.
    path: "/upavet/conciliacao",
    element: <Navigate to="/upavet/consolidacao?aba=comandas" replace />,
  },
  {
    path: "/upavet/auditoria",
    element: (
      <RotaProtegida recurso="UPAVET_AUDITORIA">
        <UpavetAuditoriaPage />
      </RotaProtegida>
    ),
  },
  {
    path: "/upavet/auditoria/:aba",
    element: (
      <RotaProtegida recurso="UPAVET_AUDITORIA">
        <UpavetAuditoriaPage />
      </RotaProtegida>
    ),
  },
  {
    path: "/upavet/transparencia",
    element: (
      <RotaProtegida recurso="UPAVET_AUDITORIA">
        <UpavetTransparenciaPage />
      </RotaProtegida>
    ),
  },
  {
    path: "/upavet/indicadores",
    element: (
      <RotaProtegida recurso="UPAVET_INDICADORES">
        <UpavetIndicadoresPage />
      </RotaProtegida>
    ),
  },
  {
    path: "/upavet/custos",
    element: (
      <RotaProtegida recurso="UPAVET_CUSTOS">
        <UpavetCustosPage />
      </RotaProtegida>
    ),
  },
  {
    // O catálogo foi unido à tela de Procedimentos (aba "Catálogo de itens").
    // Mantemos a rota antiga redirecionando para não quebrar links salvos.
    path: "/upavet/catalogo",
    element: <Navigate to="/upavet/procedimentos?aba=catalogo" replace />,
  },
  {
    path: "/upavet/executivo",
    element: (
      <RotaProtegida recurso="UPAVET_EXECUTIVO">
        <UpavetExecutivoPage />
      </RotaProtegida>
    ),
  },
  {
    path: "/upavet/fora-goiania",
    element: (
      <RotaProtegida recurso="UPAVET_FORA_GOIANIA">
        <UpavetForaGoianiaPage />
      </RotaProtegida>
    ),
  },
  {
    // Cadastros reúne a parceria (OSC, instrumentos, plano de trabalho e
    // habilitação) e a base importada (tutores, animais e vínculo).
    // Basta ter UMA das permissões para entrar; cada aba checa a sua.
    path: "/upavet/cadastros",
    element: (
      <RotaProtegida
        recurso="UPAVET_TUTORES_UNICOS"
        recursosAlternativos={[
          "UPAVET_ANIMAIS_UNICOS",
          "UPAVET_TUTOR_ANIMAIS",
          "ORGANIZACAO",
          "AUDITORIA",
        ]}
      >
        <UpavetCadastrosPage />
      </RotaProtegida>
    ),
  },
  {
    path: "/upavet/admin/tutores",
    element: (
      <RotaProtegida recurso="UPAVET_TUTORES_UNICOS" allowlist>
        <UpavetAdminTutoresPage />
      </RotaProtegida>
    ),
  },
  {
    path: "/upavet/admin/animais",
    element: (
      <RotaProtegida recurso="UPAVET_ANIMAIS_UNICOS" allowlist>
        <UpavetAdminAnimaisPage />
      </RotaProtegida>
    ),
  },
  {
    path: "/upavet/admin/tutor-animais",
    element: (
      <RotaProtegida recurso="UPAVET_TUTOR_ANIMAIS" allowlist>
        <UpavetAdminTutorAnimaisPage />
      </RotaProtegida>
    ),
  },
  {
    // A conciliação foi unida à Consolidação: o envio de comandas virou a aba
    // "Importar comandas". Mantemos a rota antiga redirecionando.
    path: "/upavet/admin/upload",
    element: <Navigate to="/upavet/consolidacao?aba=comandas" replace />,
  },
  {
    // Rota legada do Console para o item "Conciliação".
    path: "/admin/operacional/upavet/conciliacao",
    element: <Navigate to="/upavet/consolidacao?aba=comandas" replace />,
  },
  {
    path: "/upavet/diagnostico",
    element: (
      <RotaProtegida recurso="UPAVET_DIAGNOSTICO">
        <UpavetDiagnosticoPage />
      </RotaProtegida>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;